import React from "react";
import { t as i18nT } from "../../i18n";


const OwnerDashboard = () => {
  return (
    <div>
      <h1>{i18nT("common.ownerDashboard")}</h1>
      <p>{i18nT("common.welcomeOwnerYouHaveAccessToTheOwner")}</p>
    </div>
  );
};

export default OwnerDashboard;
